import React from 'react';

const CancelWarningPopup = ({ message, onConfirm, onClose }) => (
    <div className="emotion-cancel-overlay">
        <div className="emotion-cancel-popup">
            <p>{message}</p>
            <div className="emotion-cancel-actions">
                <button className="emotion-confirm-button" onClick={onConfirm}>
                    I'm sure
                </button>
                <button className="emotion-abort-button" onClick={onClose}>
                    No
                </button>
            </div>
        </div>
    </div>
);

export default CancelWarningPopup;
